import React from 'react'

import { faCheck, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from 'react-toastify'
import jwt_decode from "jwt-decode";
import Loader from '../Layout/Loader'
import { useTranslation } from "react-i18next";
import mainAxios from '../../services/mainAxios'
import { FinanceIllustration, FloatingShapes } from "./LoginIllustrations"
import './Auth.scss';

const EditPassword = (props) => {

    const { t, i18n } = useTranslation('translations');
    const [state, setState] = React.useState({
        newPassword: "",
        confirmPassword: "",
        error: null,
        error_password: null
    })
    const [loading, setLoading] = React.useState(false)
    const [passwordType, setPasswordType] = React.useState({
        newPassword: "password",
        confirmPassword: "password"
    })


    const editPassword = (e) => {
        e.preventDefault()
        const userId = props.match.params.id
        if (/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(state.newPassword)) {
            if (state.newPassword === state.confirmPassword) {
                setLoading(true)
                const token = new URLSearchParams(props.location.search).get("token")
                let username
                try {
                    username = jwt_decode(token).sub
                } catch (err) {
                    toast.error(t(['toast.invalidToken']) || "Invalid or expired reset link.", {
                        position: "top-right", autoClose: 5000, containerId: "all_toast"
                    })
                    setLoading(false)
                    return
                }
                mainAxios.post('general/resetPassword', {
                    object: "ResetPassword",
                    content: {
                        newPassword: state.newPassword,
                        token,
                    },
                    username,
                }).then(res => {
                    if (res?.data?.status === true) {
                        toast.success(t(['toast.updatePassword']), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            progress: undefined,
                            containerId: "all_toast"
                        })
                        props.history.push('/')

                    }
                    else {
                        setState(state => ({
                            ...state,
                            error: null
                        }))
                    }
                    setLoading(false)
                })
            }
            else {
                setState(state => ({
                    ...state,
                    error: t(['toast.identical'])
                }))
            }
        }
        else {
            setState(state => ({
                ...state,
                error_password: t(['toast.passwordError'])
            }))
        }

    }

    const handlePasswordInputs = (e) => {
        const key = e.target.name
        const value = e.target.value

        setState(state => ({
            ...state,
            [key]: value
        }))
    }

    return (
        <div className="auth-page-container">
            <div className="auth-sidebar auth-sidebar-modern">
                <FloatingShapes />
                <div className="sidebar-content" style={{position: 'relative', zIndex: 2}}>
                    <div className="sidebar-logo">
                        <img src="/new-logo-profisc-white.png" alt="Profisc" />
                    </div>
                    <h2 className="sidebar-title sidebar-heading">
                        {t('login.slogan')}
                    </h2>
                </div>
                <div className="aside-illustration" style={{position: 'relative', zIndex: 2}}>
                    <FinanceIllustration />
                </div>
            </div>

            <div className="auth-form-wrapper">
                <div className="auth-form-container">
                    <form onSubmit={editPassword}>
                        <h3 className="auth-form-title">
                            {t('login.resetPasswordHeader')}
                        </h3>
                        <p className="auth-form-subtitle">
                            {t('login.resetPasswordSubtitle')}
                        </p>

                        {state.error && (
                            <div className="error-message">
                                {state.error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="new_password">
                                {state.error_password && (
                                    <span className="error-text">{state.error_password}</span>
                                )}
                                {t('users.newPassword')}
                            </label>
                            <div className="password-input-wrapper">
                                <input
                                    type={passwordType.newPassword}
                                    className={"form-control" + (state.error_password ? " border-danger" : "")}
                                    id="new_password"
                                    name="newPassword"
                                    placeholder={t('users.newPassword')}
                                    value={state.newPassword}
                                    onChange={handlePasswordInputs}
                                    required />
                                <span
                                    className="password-toggle"
                                    onClick={() => setPasswordType(prev => ({
                                        ...prev,
                                        newPassword: prev.newPassword === "password" ? "text" : "password"
                                    }))}>
                                    <FontAwesomeIcon icon={passwordType.newPassword === "password" ? faEye : faEyeSlash} />
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirm_password">
                                {t('users.confirmPassword')}
                            </label>
                            <div className="password-input-wrapper">
                                <input
                                    type={passwordType.confirmPassword}
                                    className={"form-control" + (state.error ? " border-danger" : "")}
                                    id="confirm_password"
                                    name="confirmPassword"
                                    placeholder={t('users.confirmPassword')}
                                    value={state.confirmPassword}
                                    onChange={handlePasswordInputs}
                                    required />
                                <span
                                    className="password-toggle"
                                    onClick={() => setPasswordType(prev => ({
                                        ...prev,
                                        confirmPassword: prev.confirmPassword === "password" ? "text" : "password"
                                    }))}>
                                    <FontAwesomeIcon icon={passwordType.confirmPassword === "password" ? faEye : faEyeSlash} />
                                </span>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}>
                                {loading ? (
                                    <Loader size="xs" color="white" />
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faCheck} className="mr-2" />
                                        {t('common.save')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EditPassword
